import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatourpackage() {



  const cardData =
  {
    keyword: ' Pune to Ayodhya Tour Package  ',
    heading: 'Sai Trupti Cabs:  Pune to Ayodhya Tour Package  ',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Ayodhya tour package, specially designed for Ram Mandir darshan and spiritual travel, ensuring a smooth, memorable, and stress-free journey. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample luggage space for long-distance travel. Every trip is handled by a professional, background-verified driver who ensures timely pickup in Pune, safe driving, and a pleasant journey all the way to Ayodhya. We provide flexible options like customized Ayodhya darshan packages, round trip cab services, and multi-day pilgrimage tours at transparent and affordable pricing with no hidden charges. With 24x7 online booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs makes your Pune to Ayodhya tour convenient, comfortable, and spiritually fulfilling.',

    top: 'Top Places to Visit in Ayodhya with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ram Janmabhoomi",
    "description": "Ram Janmabhoomi is the legendary birthplace of Lord Rama and the most revered pilgrimage site in Ayodhya. Believed to be the site where Lord Rama was born, it attracts devotees from across India and the world. The area is undergoing development with a grand temple being constructed, designed to reflect traditional Hindu architecture. Pilgrims and visitors can immerse themselves in spiritual devotion and witness the cultural and religious significance of this historic site."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a prominent temple dedicated to Lord Hanuman, situated atop a 76-foot high hill in Ayodhya. The temple is renowned for its massive statue of Hanuman and its serene atmosphere. Devotees visit early in the morning or at sunset to witness the aarti and seek blessings. The temple’s location offers panoramic views of the city, blending spiritual experience with scenic beauty."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Rama and Goddess Sita, gifted to Sita by her mother-in-law, Kaikeyi, according to legend. The temple is adorned with intricate carvings, gold-plated doors, and colorful artwork depicting scenes from the Ramayana. It remains a center of devotion and a popular stop for pilgrims visiting Ayodhya, reflecting the rich cultural heritage of the city."
  },
  {
    "title": "Saryu River Ghats",
    "description": "The Ghats of Saryu River are sacred spots along the riverbanks where pilgrims perform rituals, take holy dips, and offer prayers. The river holds immense spiritual significance in Hinduism, and its ghats are dotted with temples and shrines. Visitors can enjoy peaceful walks, participate in religious ceremonies, or witness the mesmerizing sunrise and sunset reflecting on the river, creating a serene spiritual experience."
  },
  {
    "title": "Treta Ke Thakur",
    "description": "Treta Ke Thakur is an ancient temple believed to mark the place where Lord Rama performed the Ashwamedha Yagna. The temple houses idols of Lord Rama, Sita, Lakshman, and Hanuman. Pilgrims visit to seek blessings and perform rituals. The temple’s historic and religious significance makes it a key attraction for devotees exploring Ayodhya."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat is a sacred ghat along the Saryu River, believed to be the site where Lord Rama took a dip after returning from exile. The ghat is less crowded, providing a peaceful atmosphere for meditation and reflection. Devotees perform rituals and offer prayers here, connecting deeply with the spiritual essence of Ayodhya."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple is dedicated to Lord Shiva and is associated with legends involving Lord Rama’s exile. Built in traditional Hindu architectural style, it attracts devotees for its spiritual significance and serene environment. The temple is also famous for its annual fairs and festivals, drawing visitors from nearby regions and beyond."
  },
  {
    "title": "Ram Katha Park",
    "description": "Ram Katha Park is a beautifully landscaped park near the Ram Janmabhoomi complex, dedicated to the stories and legends of Lord Rama. The park features sculptures, thematic installations, and walking trails for visitors to enjoy. It provides a calm and educational space for families, tourists, and devotees to connect with the cultural heritage of Ayodhya."
  },
  {
    "title": "Sitamarhi Tila",
    "description": "Sitamarhi Tila is a sacred mound in Ayodhya believed to be associated with Sita, the consort of Lord Rama. According to local legends, it marks the place where Sita was found in the earth. The site includes temples and shrines dedicated to Sita and attracts pilgrims seeking blessings and spiritual connection."
  },
  {
    "title": "Treta Ke Thakur Museum",
    "description": "Treta Ke Thakur Museum showcases artifacts, manuscripts, and religious relics related to the life and legends of Lord Rama. The museum offers insights into Ayodhya’s history, architecture, and cultural traditions. Visitors can learn about the Ramayana and explore the rich heritage of the city in an educational and immersive environment."
  }
],



  "services": [
    {
      "name": "Pune to Ayodhya Cab Service",
      "description": "Reliable cab service from Pune to Ayodhya offering AC/non-AC Sedans, SUVs, Innova, Crysta, and Tempo Traveller options. Includes professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and transparent fares. Ideal for family trips, religious tours, corporate travel, and long-distance commutes."
    },
    {
      "name": "Pune to Ayodhya Cab",
      "description": "Comfortable and convenient cab from Pune to Ayodhya with multiple vehicle options, AC/non-AC rides, professional drivers, and luggage assistance. Perfect for solo travelers, groups, or families seeking hassle-free long-distance travel."
    },
    {
      "name": "Pune to Ayodhya Taxi",
      "description": "Efficient taxi service from Pune to Ayodhya offering AC/non-AC vehicles, flexible schedules, experienced drivers, luggage support, and online booking. Ideal for one-way trips, round trips, and corporate travel."
    },
    {
      "name": "Pune to Ayodhya Outstation Cab",
      "description": "Outstation cab service from Pune to Ayodhya providing long-distance travel comfort with AC/non-AC Sedans, SUVs, and Innova. Features professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and transparent fares."
    },
    {
      "name": "Pune to Ayodhya Car Rentals",
      "description": "Car rental service from Pune to Ayodhya offering Sedans, SUVs, Innova, and Tempo Traveller with professional drivers, AC/non-AC options, luggage support, and flexible schedules. Perfect for customized itineraries, family trips, and group travel."
    },
    {
      "name": "Pune to Ayodhya Cab Booking",
      "description": "Book your Pune to Ayodhya cab online with secure payments, multiple vehicle options, AC/non-AC rides, professional drivers, luggage assistance, flexible pickup/drop points, and real-time tracking for a stress-free journey."
    },
    {
      "name": "Pune to Ayodhya Taxi Booking Online",
      "description": "Convenient online taxi booking from Pune to Ayodhya offering AC/non-AC vehicles, professional drivers, flexible schedules, luggage support, transparent fares, and round-trip or one-way options for business or leisure travel."
    },
    {
      "name": "Best Pune to Ayodhya Cab Service",
      "description": "Top-rated cab service from Pune to Ayodhya providing comfortable and safe AC/non-AC vehicles, experienced drivers, luggage assistance, real-time tracking, flexible pickup/drop points, and reliable long-distance travel solutions."
    },
    {
      "name": "Cheap Pune to Ayodhya Cab",
      "description": "Affordable cab service from Pune to Ayodhya offering AC/non-AC Sedans, SUVs, and Innova at budget-friendly prices with professional drivers, luggage support, and transparent fares. Ideal for students, families, and economical travelers."
    },
    {
      "name": "Pune to Ayodhya One Way Cab",
      "description": "Direct one-way cab service from Pune to Ayodhya with AC/non-AC vehicles, professional drivers, luggage assistance, real-time tracking, flexible pickup/drop points, and transparent fares for a hassle-free travel experience."
    },
    {
      "name": "Pune to Ayodhya Round Trip Taxi",
      "description": "Round-trip taxi service from Pune to Ayodhya providing comfortable AC/non-AC vehicles, experienced drivers, luggage support, flexible schedules, real-time tracking, and transparent fares for family, corporate, and group trips."
    },
    {
      "name": "Pune to Ayodhya Innova Cab",
      "description": "Spacious Innova cab service from Pune to Ayodhya offering AC rides, comfortable seating for families or groups, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for long-distance travel."
    },
    {
      "name": "Pune to Ayodhya Innova Crysta Cab",
      "description": "Premium Innova Crysta cab from Pune to Ayodhya providing luxury AC rides, professional chauffeurs, luggage assistance, comfortable seating for corporate travelers, families, or groups, with flexible pickup/drop points and transparent fares."
    },
    {
      "name": "Pune to Ayodhya Ertiga Cab",
      "description": "Ertiga cab service from Pune to Ayodhya offering AC/non-AC rides, seating for small to medium groups, professional drivers, luggage support, flexible schedules, and safe long-distance travel."
    },
    {
      "name": "Pune to Ayodhya Sedan Cab",
      "description": "Sedan cab service from Pune to Ayodhya providing smooth AC/non-AC rides, professional drivers, luggage assistance, flexible pickup/drop points, and reliable long-distance travel for solo travelers, couples, or small families."
    },
    {
      "name": "Pune to Ayodhya SUV Taxi",
      "description": "SUV taxi service from Pune to Ayodhya offering spacious AC/non-AC rides, professional drivers, luggage support, flexible pickup/drop points, and safe, comfortable travel for family trips and group travel."
    },
    {
      "name": "Pune to Ayodhya AC Cab",
      "description": "AC cab service from Pune to Ayodhya providing cool, comfortable, and safe travel with professional drivers, luggage assistance, multiple vehicle options, flexible schedules, and transparent fares for long-distance journeys."
    },
    {
      "name": "Pune to Ayodhya Tempo Traveller",
      "description": "Tempo Traveller cab service from Pune to Ayodhya suitable for large groups or family trips, offering AC/non-AC rides, spacious seating, professional drivers, luggage support, flexible pickup/drop points, and reliable long-distance travel."
    },
    {
      "name": "Pune Airport to Ayodhya Cab",
      "description": "Direct airport cab service from Pune Airport to Ayodhya offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and convenient booking for travelers."
    },
    {
      "name": "Hinjewadi to Ayodhya Taxi",
      "description": "Taxi service from Hinjewadi to Ayodhya with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and safe, comfortable long-distance travel for corporate or personal trips."
    },
    {
      "name": "Wakad to Ayodhya Cab",
      "description": "Cab service from Wakad to Ayodhya offering AC/non-AC vehicles, experienced drivers, luggage support, flexible pickup/drop points, and reliable point-to-point travel for families, corporate commuters, and solo travelers."
    },
    {
      "name": "Hadapsar to Ayodhya Taxi",
      "description": "Professional taxi service from Hadapsar to Ayodhya providing AC/non-AC rides, luggage assistance, experienced drivers, flexible schedules, and safe long-distance travel for individuals, families, and corporate clients."
    },
    {
      "name": "Pimpri Chinchwad to Ayodhya Cab",
      "description": "Reliable cab service from Pimpri Chinchwad to Ayodhya with AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and safe, comfortable long-distance travel."
    },
    {
      "name": "Pune to Ayodhya Cab Near Me",
      "description": "Quick and convenient cab booking from nearby Pune locations to Ayodhya, offering AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and reliable long-distance travel."
    },
    {
      "name": "Mumbai to Ayodhya Cabs Service",
      "description": "Cab service from Mumbai to Ayodhya offering AC/non-AC Sedans, SUVs, Innova, and Crysta for long-distance travel. Features professional drivers, luggage support, flexible pickup/drop points, online booking, and transparent fares."
    },
    {
      "name": "Mumbai to Ayodhya Cab",
      "description": "Comfortable and convenient Mumbai to Ayodhya cab with multiple vehicle options, professional drivers, luggage assistance, and AC/non-AC rides. Perfect for solo travelers, families, and group trips."
    },
    {
      "name": "Mumbai to Ayodhya Taxi",
      "description": "Reliable taxi service from Mumbai to Ayodhya offering AC/non-AC vehicles, experienced drivers, luggage assistance, flexible schedules, and online booking for one-way or round-trip travel."
    },
    {
      "name": "Mumbai Airport to Ayodhya Cab",
      "description": "Direct airport cab service from Mumbai Airport to Ayodhya with AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and convenient booking."
    },
    {
      "name": "Andheri to Ayodhya Taxi",
      "description": "Taxi service from Andheri to Ayodhya offering AC/non-AC rides, professional drivers, luggage support, flexible schedules, and safe long-distance travel for families and corporate travelers."
    },
    {
      "name": "Borivali to Ayodhya Cab",
      "description": "Cab service from Borivali to Ayodhya with AC/non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop points, and reliable long-distance travel."
    },
    {
      "name": "Thane to Ayodhya Taxi",
      "description": "Professional taxi service from Thane to Ayodhya offering AC/non-AC rides, experienced drivers, luggage support, flexible schedules, and safe travel for individuals, families, and corporate clients."
    },
    {
      "name": "Navi Mumbai to Ayodhya Cab",
      "description": "Convenient cab service from Navi Mumbai to Ayodhya with AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and reliable long-distance travel for families, groups, and business travelers."
    }
  ],
  "tableData": [
    ["Pune to Ayodhya Cab Service", "Pune to Ayodhya Cab"],
    ["Pune to Ayodhya Taxi", "Pune to Ayodhya Outstation Cab"],
    ["Pune to Ayodhya Car Rentals", "Pune to Ayodhya Cab Booking"],
    ["Pune to Ayodhya Taxi Booking Online", "Best Pune to Ayodhya Cab Service"],
    ["Cheap Pune to Ayodhya Cab", "Pune to Ayodhya One Way Cab"],
    ["Pune to Ayodhya Round Trip Taxi", "Pune to Ayodhya Innova Cab"],
    ["Pune to Ayodhya Innova Crysta Cab", "Pune to Ayodhya Ertiga Cab"],
    ["Pune to Ayodhya Sedan Cab", "Pune to Ayodhya SUV Taxi"],
    ["Pune to Ayodhya AC Cab", "Pune to Ayodhya Tempo Traveller"],
    ["Pune Airport to Ayodhya Cab", "Hinjewadi to Ayodhya Taxi"],
    ["Wakad to Ayodhya Cab", "Hadapsar to Ayodhya Taxi"],
    ["Pimpri Chinchwad to Ayodhya Cab", "Pune to Ayodhya Cab Near Me"],
    ["Mumbai to Ayodhya Cabs Service", "Mumbai to Ayodhya Cab"],
    ["Mumbai to Ayodhya Taxi", "Mumbai Airport to Ayodhya Cab"],
    ["Andheri to Ayodhya Taxi", "Borivali to Ayodhya Cab"],
    ["Thane to Ayodhya Taxi", "Navi Mumbai to Ayodhya Cab"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Ayodhya Tour Package",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and reliable tour packages from Pune to Ayodhya — perfect for religious trips, family travel, and group journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our Pune to Ayodhya tour packages start from approximately ₹18,000–₹25,000 for sedans, with SUVs and premium vehicles available at affordable rates depending on group size and travel duration."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage requirements, and comfort preferences for the Pune → Ayodhya route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced in long-distance interstate travel from Pune to Ayodhya, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs at your Ayodhya destination, hotels, or pilgrimage sites."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic long-distance trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, route planning, or travel assistance for your Pune to Ayodhya tour."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Ayodhya tour package easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Ayodhya tour packages?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable tour packages from Pune to Ayodhya for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to Ayodhya tour package with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Ayodhya tour package through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Pune to Ayodhya tours?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Pune to Ayodhya travel.',
  },
  {
    question: 'Are the drivers experienced for Pune to Ayodhya trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance interstate travel.',
  },
  {
    question: 'Can I hire a cab from Pune to Ayodhya for multi-day tours?',
    answer: 'Yes, we provide flexible tour packages for multi-day trips, group travel, and family pilgrimages to Ayodhya.',
  },
  {
    question: 'Is the Pune to Ayodhya tour package available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 booking and support for Pune to Ayodhya tours.',
  },
  {
    question: 'What are the Pune to Ayodhya tour package fares?',
    answer: 'Our fares start from approximately ₹18,000 for sedans and ₹25,000–₹35,000 for SUVs and premium vehicles, depending on distance, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Ayodhya tour packages?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Ayodhya tours?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Ayodhya tour?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Pune to Ayodhya tour package journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Sharma',
    feedback: 'Booked a Pune to Ayodhya tour package. Comfortable ride, polite driver, and hassle-free experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'Excellent Pune to Ayodhya tour service. On-time pickup and well-maintained vehicle.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Ayodhya Tour Package",
  "image": "https://saitrupticabs.com/assets/images/pune-to-ayodhya-tour.jpg",
  "description": "Sai Trupti Cabs offers Pune to Ayodhya tour package for Ram Mandir darshan with multi-day cab travel. Book Innova Crysta, Ertiga, sedan and SUV for safe and comfortable pilgrimage with professional drivers and 24x7 support.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-ayodhya-tour-package",
    "itemCondition": "https://schema.org/NewCondition"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pune to Ayodhya Tour Package | Ram Mandir Darshan ₹18999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Ayodhya tour package for Ram Mandir darshan at ₹18999. Travel by Innova Crysta, SUV or sedan with Sai Trupti Cabs. Safe and comfortable pilgrimage tour with 24x7 booking." 
  />

  <meta 
    name="keywords" 
    content="pune to ayodhya tour package, pune to ram mandir cab, pune to ayodhya taxi, ayodhya darshan package pune, pune to ayodhya cab booking, ram mandir tour from pune, pune to ayodhya innova package, pune to ayodhya suv tour, ayodhya pilgrimage cab pune, pune to ayodhya round trip cab, cheap ayodhya tour pune, religious tour ayodhya from pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoayodhyatourpackage;